import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>Copyright © 2024 ZW Dining Group. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
